module.exports = __webpack_public_path__ + "img/back-2-n-d6f74c11.png";